import { actionTypes } from 'actions/patientAdherence';

const initialState = {
  clinicId: '',
};

export default (
  state: IPatientAdherenceState = initialState,
  action: Action<any>,
): IPatientAdherenceState => {
  switch (action.type) {
    case actionTypes.SELECT_CLINIC_ADHERENCE: {
      return {
        ...state,
        clinicId: action.payload.clinicId,
      };
    }
    default: {
      return state;
    }
  }
};
